import React from 'react';
import {AisinoFormItem} from "../../../baseComponent/form";
import {CommonDictSelect} from "../index";
import {formItemTailLayout} from "../../../constant/css";


class FormItemDictSelect extends React.Component {

    getData(){
        return this.refs.select.getData();
    }
    render() {
        return(
            <AisinoFormItem  {...formItemTailLayout}
                             {...this.props} onChange={this.props.onChangeItem}>
                <CommonDictSelect ref={"select"} {...this.props}/>
            </AisinoFormItem>
        );
    }
}

export default FormItemDictSelect;